import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { VersionResDto } from '../_dtos/versionResDto';

@Injectable({
  providedIn: 'root',
})
export class StatusService {
  private readonly apiUrl = `${environment.backendBaseUrl}/status`;

  constructor(private http: HttpClient) {}

  getVersion(): Observable<VersionResDto> {
    return this.http.get<VersionResDto>(`${this.apiUrl}/version`);
  }
}
